export * from "./CognitoIdentityClient";
export * from "./CognitoIdentity";
export * from "./commands/CreateIdentityPoolCommand";
export * from "./commands/DeleteIdentitiesCommand";
export * from "./commands/DeleteIdentityPoolCommand";
export * from "./commands/DescribeIdentityCommand";
export * from "./commands/DescribeIdentityPoolCommand";
export * from "./commands/GetCredentialsForIdentityCommand";
export * from "./commands/GetIdCommand";
export * from "./commands/GetIdentityPoolRolesCommand";
export * from "./commands/GetOpenIdTokenCommand";
export * from "./commands/GetOpenIdTokenForDeveloperIdentityCommand";
export * from "./commands/ListIdentitiesCommand";
export * from "./commands/ListIdentityPoolsCommand";
export * from "./pagination/ListIdentityPoolsPaginator";
export * from "./commands/ListTagsForResourceCommand";
export * from "./commands/LookupDeveloperIdentityCommand";
export * from "./commands/MergeDeveloperIdentitiesCommand";
export * from "./commands/SetIdentityPoolRolesCommand";
export * from "./commands/TagResourceCommand";
export * from "./commands/UnlinkDeveloperIdentityCommand";
export * from "./commands/UnlinkIdentityCommand";
export * from "./commands/UntagResourceCommand";
export * from "./commands/UpdateIdentityPoolCommand";
export * from "./pagination/Interfaces";
export * from "./models/index";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@aws-sdk/client-cognito-identity/dist/es/index.js
// module id = 528
// module chunks = 0